/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Company } from '../models/company';
import { getManyBaseMgmtCompanyControllerCompany } from '../fn/company/get-many-base-mgmt-company-controller-company';
import { GetManyBaseMgmtCompanyControllerCompany$Params } from '../fn/company/get-many-base-mgmt-company-controller-company';
import { getManyBaseMyCompanyControllerCompany } from '../fn/company/get-many-base-my-company-controller-company';
import { GetManyBaseMyCompanyControllerCompany$Params } from '../fn/company/get-many-base-my-company-controller-company';
import { GetManyCompanyResponseDto } from '../models/get-many-company-response-dto';
import { getOneBaseMgmtCompanyControllerCompany } from '../fn/company/get-one-base-mgmt-company-controller-company';
import { GetOneBaseMgmtCompanyControllerCompany$Params } from '../fn/company/get-one-base-mgmt-company-controller-company';
import { getOneBaseMyCompanyControllerCompany } from '../fn/company/get-one-base-my-company-controller-company';
import { GetOneBaseMyCompanyControllerCompany$Params } from '../fn/company/get-one-base-my-company-controller-company';

@Injectable({ providedIn: 'root' })
export class CompanyApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getManyBaseMgmtCompanyControllerCompany()` */
  static readonly GetManyBaseMgmtCompanyControllerCompanyPath = '/api/mgmt/companies';

  /**
   * Retrieve multiple Companies.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getManyBaseMgmtCompanyControllerCompany()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtCompanyControllerCompany$Response(params?: GetManyBaseMgmtCompanyControllerCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<GetManyCompanyResponseDto>> {
    const obs = getManyBaseMgmtCompanyControllerCompany(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve multiple Companies.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getManyBaseMgmtCompanyControllerCompany$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtCompanyControllerCompany(params?: GetManyBaseMgmtCompanyControllerCompany$Params, context?: HttpContext): Observable<GetManyCompanyResponseDto> {
    const resp = this.getManyBaseMgmtCompanyControllerCompany$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetManyCompanyResponseDto>): GetManyCompanyResponseDto => r.body)
    );
  }

  /** Path part for operation `getOneBaseMgmtCompanyControllerCompany()` */
  static readonly GetOneBaseMgmtCompanyControllerCompanyPath = '/api/mgmt/companies/{id}';

  /**
   * Retrieve a single Company.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOneBaseMgmtCompanyControllerCompany()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtCompanyControllerCompany$Response(params: GetOneBaseMgmtCompanyControllerCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<Company>> {
    const obs = getOneBaseMgmtCompanyControllerCompany(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a single Company.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOneBaseMgmtCompanyControllerCompany$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtCompanyControllerCompany(params: GetOneBaseMgmtCompanyControllerCompany$Params, context?: HttpContext): Observable<Company> {
    const resp = this.getOneBaseMgmtCompanyControllerCompany$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Company>): Company => r.body)
    );
  }

  /** Path part for operation `getOneBaseMyCompanyControllerCompany()` */
  static readonly GetOneBaseMyCompanyControllerCompanyPath = '/api/my/companies/{id}';

  /**
   * Retrieve a single Company.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOneBaseMyCompanyControllerCompany()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMyCompanyControllerCompany$Response(params: GetOneBaseMyCompanyControllerCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<Company>> {
    const obs = getOneBaseMyCompanyControllerCompany(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a single Company.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOneBaseMyCompanyControllerCompany$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMyCompanyControllerCompany(params: GetOneBaseMyCompanyControllerCompany$Params, context?: HttpContext): Observable<Company> {
    const resp = this.getOneBaseMyCompanyControllerCompany$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Company>): Company => r.body)
    );
  }

  /** Path part for operation `getManyBaseMyCompanyControllerCompany()` */
  static readonly GetManyBaseMyCompanyControllerCompanyPath = '/api/my/companies';

  /**
   * Retrieve multiple Companies.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getManyBaseMyCompanyControllerCompany()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMyCompanyControllerCompany$Response(params?: GetManyBaseMyCompanyControllerCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<GetManyCompanyResponseDto>> {
    const obs = getManyBaseMyCompanyControllerCompany(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve multiple Companies.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getManyBaseMyCompanyControllerCompany$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMyCompanyControllerCompany(params?: GetManyBaseMyCompanyControllerCompany$Params, context?: HttpContext): Observable<GetManyCompanyResponseDto> {
    const resp = this.getManyBaseMyCompanyControllerCompany$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetManyCompanyResponseDto>): GetManyCompanyResponseDto => r.body)
    );
  }

}
